<template>
  <v-app-bar color="blue-grey lighten-1">
    <v-btn text small to="/" class="title white--text green"
      >Kiuruveden palvelut</v-btn
    >
  </v-app-bar>
</template>

<script>
export default {
  name: 'GlobalNav',
  data: () => ({
    //
  })
}
</script>
